import { createStore } from 'vuex';
import api from '../api';

export default createStore({
  state: {
    token: localStorage.getItem('token') || '',
    user: null,
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
      localStorage.setItem('token', token);
    },
    logout(state) {
      state.token = '';
      localStorage.removeItem('token');
    },
  },
  actions: {
    async login({ commit }, credentials) {
      const response = await api.post('/login', credentials);
      commit('setToken', response.data.token);
    },
  },
});
